import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthGuard } from './components/AuthGuard';
import { AdminGuard } from './components/AdminGuard';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import VenueFinder from './pages/VenueFinder';
import VendorDirectory from './pages/VendorDirectory';
import GuestManagement from './pages/GuestManagement';
import BudgetPlanning from './pages/BudgetPlanning';
import DayOfPlanning from './pages/DayOfPlanning';
import RegistryList from './pages/RegistryList';
import RegistryDetails from './pages/RegistryDetails';
import CreateRegistry from './pages/CreateRegistry';
import Profile from './pages/Profile';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import RSVPPage from './pages/RSVPPage';
import AdminDashboard from './pages/AdminDashboard';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermsConditions from './pages/TermsConditions';
import PaymentSuccess from './pages/payment/Success';
import PaymentCancel from './pages/payment/Cancel';
import AuthCallback from './pages/AuthCallback';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/rsvp/:id" element={<RSVPPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          
          {/* Public registry route with Layout */}
          <Route element={<Layout />}>
            <Route path="/registries/:id" element={<RegistryDetails />} />
          </Route>
          
          {/* Protected routes with Layout */}
          <Route element={<AuthGuard><Layout /></AuthGuard>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/venues" element={<VenueFinder />} />
            <Route path="/vendors" element={<VendorDirectory />} />
            <Route path="/guest-management" element={<GuestManagement />} />
            <Route path="/budget" element={<BudgetPlanning />} />
            <Route path="/day-of-planning" element={<DayOfPlanning />} />
            <Route path="/gift-registry" element={<GuestManagement />} />
            <Route path="/registries" element={<RegistryList />} />
            <Route path="/create" element={<CreateRegistry />} />
            <Route path="/profile" element={<Profile />} />
          </Route>

          {/* Admin routes */}
          <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
          <Route path="/admin/analytics" element={<AdminGuard><AnalyticsDashboard /></AdminGuard>} />

          {/* Catch all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}